import React from 'react';
import styled from 'styled-components';
import { ScaleLoader } from 'react-spinners';

const LoaderContainer = styled.div`
  width: 50px;
  margin: auto;
`;

export default function Loader(props) {
  return (
    <LoaderContainer>
      <ScaleLoader sizeUnit={'px'} size={20} color={'#e25d34'} {...props} />
    </LoaderContainer>
  );
}
